"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M1706.235 1807.059H350.941V112.94h903.53v451.765h451.764v1242.353zm-338.823-1670.74l315.443 315.447h-315.443V136.32zm402.182 242.487L1440.372 49.58C1408.296 17.62 1365.717 0 1320.542 0H238v1920h1581.175V498.635c0-45.176-17.618-87.755-49.58-119.83zM576.823 1242.353h790.589v-112.94H576.823v112.94zm0-451.765h903.53V677.647h-903.53v112.941zm0 677.647h451.765v-112.941H576.823v112.941zm0-451.764h677.648V903.53H576.823v112.941zm0-451.765h451.765V451.765H576.823v112.941z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconDocument = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconDocument, _Component);
  function IconDocument() {
    (0, _classCallCheck2.default)(this, IconDocument);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconDocument).apply(this, arguments));
  }
  (0, _createClass2.default)(IconDocument, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconDocument",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);
  IconDocument.displayName = "IconDocument";
  return IconDocument;
}(_react.Component);
exports.default = IconDocument;
IconDocument.glyphName = 'document';
IconDocument.variant = 'Line';
IconDocument.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);